angular.module('leanlaw').controller('MatterTagRevenueCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', 'accountingService', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts, userService, reportsService, commonFilterService, accountingService, exportJson, singleRequest, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = 'mattertag.label';
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  function exportLine(tag, data, total) {
    const include = $scope.filter.include;
    const line = {
      "Practice Area": tag.label
    };
    if (include.detail) {
      if ($scope.filter.show.billed) {
        line["Billed Hours"] = $filter("amount")(data.billed.hours);
        line["Billed Expenses"] = $filter("amount")(data.billed.expensesTotal);
        line["Billed Fixed fees"] = $filter("amount")(data.billed.chargesTotal);
        line["Billed Credits"] = $filter("amount")(data.billed.credits);
      }
      if (total.billed && total.billed.adjustments) {
        line["Adjustments"] = $filter("amount")(data.billed.adjustments);
      }
      if (total.billed && total.billed.tax) {
        line["Tax"] = $filter("amount")(data.billed.tax);
      }
    }
    if ($scope.filter.show.billed) {
      const label = include.detail ? "Total Billed" : "Billed";
      line[label] = $filter("amount")(data.billed.total);
    }
    line["Collected"] = data.collected.servicesTotal ? $filter("amount")(data.collected.servicesTotal) : "";
    return line;
  }
  $scope.export = function () {
    const exp = $scope.data.filteredMatterTags.reduce((accum, c) => {
      accum.push(exportLine(c.mattertag, c.data, $scope.data.data));
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.goToSummary = function (tag) {
    $state.go("reports.practice-area-revenue-detail", {
      matterTag: tag.id,
      return: "reports.practice-area-revenue",
      report: `Revenue by Client and ${$scope.me.terms.Matter}`
    });
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      $scope.trust = me.company.settings.trustEnabled;
      accountingService.verify(false).then(status => {
        $scope.accounting = status.connected;
      }).catch(err => {
        $scope.accounting = false;
      }).then(() => {
        $scope.ready = true;
        requestReport();
      });
    });
  }
  function requestReport() {
    if (!$scope.ready) return;
    $scope.loading = true;
    const query = reportsService.queryFromFilter($scope.filter);
    query.primary = 'mattertag';
    query.billingType = '-internal';
    query.data = "invoices";
    query.reportType = "revenue";
    if ($scope.accounting) {
      query.data += ",payments";
    }
    if (!$scope.filter.show.billed) {
      query.data = "payments";
    }
    singleRequest.serviceCall("requestReport", reportsService.getReport)(query).then(data => {
      if (!data) return;
      $scope.loading = false;
      $scope.data = data;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("requestReport");
    deactivate();
  });
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    if (!payload) return;
    // Assigning to existing filter keeps custom filter options
    $scope.filter = Object.assign($scope.filter, payload);
    // Necessary to set this value for the requests
    $scope.filter.status = $scope.filter.archived.status;
    $scope.filter.scope = $scope.filter.filter.scope;
    if (payload.filter.range) {
      requestReport();
    }
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    $scope.filter = Object.assign($scope.filter, payload);
  });

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage("filterDependency-ready", true);

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredMatterTags = $filter('orderBy')($filter('filter')($scope.data.matterTags, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.matterTags', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);